import {
	SET_INSTRUCTIONS,
	SET_INSTRUCTION,
	CLEAR_INSTRUCTIONS,
	CLEAR_INSTRUCTION,
	ADD_INSTRUCTION,
	UPDATE_INSTRUCTION,
	REMOVE_INSTRUCTION,
} from './actionTypes';

export const instruction = (state = {}, action) => {
	switch (action.type) {
		case SET_INSTRUCTION:
			return action.payload;
		case UPDATE_INSTRUCTION:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_INSTRUCTION:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_INSTRUCTIONS:
			return action.payload;
		case ADD_INSTRUCTION:
			return [...state, action.payload];
		case UPDATE_INSTRUCTION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_INSTRUCTION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_INSTRUCTIONS:
			return [];
		default:
			return state;
	}
};
